/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { useState, useCallback, useEffect, useContext, useRef, Suspense } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Checkbox, CheckboxProps } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { green } from "@material-ui/core/colors";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "./alertSubscriptionGrid.css";
import { ColumnApi, GridApi, GridReadyEvent } from "ag-grid-community";
import initCapitalize from "../../../../../utils/commonFunctions/initCapitalize";
import { dateTimeZoneConverter } from "../../../../../utils/commonFunctions/date";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../utils/api";
import { AlertSubscriptionPayload } from "../../../../../@types/alertSubscriptionManagement";
import { ALERT_SUBSCRIPTION_FIELD } from "../../../../../constants/alertSubscriptionFields";
import { AuthContext } from "../../../../../contexts";
import ROLES from "../../../../../constants/roles";
import { CustomDialog } from "../../../../shared";
import { useEmployerRoute } from "../../../../../hooks";

// import { CustomPagination } from "../../../../shared";

const GreenCheckbox = withStyles({
	root: {
		color: green[400],
		"&$checked": {
			color: green[600]
		}
	},
	// onClick: {},
	checked: {}
})((props: CheckboxProps) => <Checkbox color="default" {...props} size="small" />);

// eslint-disable-next-line react/prop-types
const AlertSubscriptionGrid = ({
	gridProps,
	tabValue,
	setGridProps,
	permission,
	getGroupOwners,
	groupNumber,
	payloadForEmailOrNotifications,
	setPayloadForEmailOrNotifications
}: any) => {
	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const agGridRef = useRef<any>(null);
	const [isEmployer, setIsEmployer] = useState(false);
	const { user } = useContext(AuthContext);

	const [customSaveDialogProps, setCustomSaveDialogProps] = useState({
		openDialog: false,
		title: "Do you want to save this update?",
		content: "alert subscriptions will be updated as per current checked subscriptions",
		actions: [
			{
				label: "Cancel",
				name: "cancel",
				callback: () => {
					getGroupOwners();
					setCustomSaveDialogProps(Object.assign({}, customSaveDialogProps, { openDialog: false }));
				}
			},
			{
				label: "Yes",
				name: "accept",
				callback: () => {
					handleEditBulkAlertSubscription();
				}
			}
		]
	});
	// const [pagination, setPagination] = useState({
	// 	currentPage: 1,
	// 	pageCount: 5
	// });
	const [agGridColumnAPI, setAgGridColumnAPI] = useState(null);
	const [selectedRowData, setSelectedRowData] = useState([]);
	const [isRowSelected, setIsRowSelected] = useState(false);

	const payloadRef = useRef<AlertSubscriptionPayload[]>([]);

	const alertSubscriptionsPermission = permission;

	// console.log(permission, "alertSubscriptionsPermission");

	// const { currentPage, pageCount } = pagination;
	// eslint-disable-next-line
	const handleAgGridReady = (params: any) => {
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
	};

	// eslint-disable-next-line
	const handleFirstDataRendered = (params: any) => {
		params.api.sizeColumnsToFit();
		params.columnApi.setColumnWidth("action", "100%", true);
		const { api, columnApi } = params;
		api.sizeColumnsToFit();
	};

	const handleUserRoleCellRenderer = ({ value }: { value: string }) => {
		const role = initCapitalize(value);
		return <div>{role}</div>;
	};

	const handleSSNCellRenderer = ({ value }: { value: string }) => {
		const SSN = value ? value.substring(0, 3) + "-" + value.substring(3, 5) + "-" + value.substring(5) : "N/A";
		return <div>{SSN}</div>;
	};

	const handleDateCellRenderer = ({ value }: { value: string }) => (value ? dateTimeZoneConverter(value) : "N/A");

	const handleSelectionChanged = useCallback(() => {
		// console.log("agGridAPI", gridApi);
		// const selectedRow = agGridAPI?.getSelectedRows();
		const selectedRow = agGridRef.current.api.getSelectedRows();
		// console.log("Selected Row", selectedRow);
		setSelectedRowData(Object.assign([], selectedRow));
		if (selectedRow) {
			setIsRowSelected(true);
		} else {
			setIsRowSelected(false);
		}
	}, []);

	// console.log("gridProps", gridProps);

	const checkValueChangeClick = useCallback(
		async (event: any, value: any) => {
			const checked = event.target.checked;
			// console.log("Checked rf", checked);
			const focusedCell = agGridRef.current.api.getFocusedCell();
			const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);

			// Update the cell visually
			// Use functional state update to ensure latest state
			// console.log("started", gridProps);

			if (!alertSubscriptionsPermission.update) {
				alert("you don't have update permission");
				return;
			}

			const updatedSubscription = {
				...row.data.subscription,
				[value]: { ...row.data.subscription[value], [tabValue]: checked } // Update the checkbox state
			};

			const updatedRow = {
				...row.data,
				subscription: updatedSubscription
			};

			// console.log("Updated Row:", updatedRow);

			// ✅ First, update Ag-Grid without a full re-render
			row.setData(updatedRow);

			const { data } = row;
			const { _id } = data;

			const payload: any = {
				_id: _id,
				// alert_field: value,
				group_number: groupNumber,
				alert_type: tabValue,
				[value]: checked
			};

			payloadRef.current = payloadRef.current.filter((p: AlertSubscriptionPayload) => p.alert_type == tabValue);

			const existingIndex = payloadRef.current.findIndex((p) => p._id === _id);
			// console.log("existingIndex", existingIndex);
			if (existingIndex === -1) {
				payloadRef.current.push(payload);
			} else {
				const existingPayload: AlertSubscriptionPayload = payloadRef.current[existingIndex];
				// console.log("existingIndex", existingPayload);
				if (value in existingPayload) {
					delete existingPayload[value];
					if (Object.keys(existingPayload).length > 2) {
						payloadRef.current.splice(existingIndex, 1);
						payloadRef.current.push(existingPayload);
					} else {
						payloadRef.current.splice(existingIndex, 1);
					}
				} else {
					existingPayload[value] = checked;
					payloadRef.current.splice(existingIndex, 1);
					payloadRef.current.push(existingPayload);
				}
			}

			// Set state with updated ref value
			setPayloadForEmailOrNotifications([...payloadRef.current]);
			// console.log("payload", payload);
		},

		[gridProps, setPayloadForEmailOrNotifications, tabValue, alertSubscriptionsPermission, groupNumber]
	);

	const handleCloseModalBulkAlertSubscription = useCallback(() => {
		setCustomSaveDialogProps(Object.assign({}, customSaveDialogProps, { openDialog: false }));
	}, [customSaveDialogProps]);

	const handleOpenModalBulkAlertSubscription = useCallback(() => {
		setCustomSaveDialogProps(Object.assign({}, customSaveDialogProps, { openDialog: true }));
	}, [customSaveDialogProps]);

	const handleEditBulkAlertSubscription = useCallback(async () => {
		try {
			// console.log("testing", payloadRef.current);
			const response = await trackPromise(
				api.alertSubscriptionManagement.editBulkAlertSubscription(payloadRef.current)
			);

			if (response) {
				// console.log("Alert Response", response);
				alert("edit bulk alert subscriptions Successful!");
				setCustomSaveDialogProps(Object.assign({}, customSaveDialogProps, { openDialog: false }));
				payloadRef.current = [];
				// getGroupOwners();
				window.location.reload();
			}
		} catch (error) {
			alert("edit bulk alert subscriptions Unsuccessful!");
			setCustomSaveDialogProps(Object.assign({}, customSaveDialogProps, { openDialog: false }));
			throw error;
		}
	}, [getGroupOwners]);

	const checkValueChange = useCallback(
		(event: any, value: any) => {
			const checked = event.target.checked;
			// console.log("Checked", checked);
			const focusedCell = agGridRef.current.api.getFocusedCell();
			const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell.rowIndex);
			const { data } = row;
			const { _id } = data;
			// console.log("id", _id);
			// console.log("gridProps", gridProps);
			gridProps?.map((group: any, index: number) => {
				// console.log("group._id", group._id);
				if (group.id === _id) {
					const newObj = Object.assign({}, group.subscription[value], {
						[tabValue]: !group.subscription[value][tabValue]
					});
					const newObj1 = Object.assign({}, group.subscription, { [value]: newObj });
					const newObj2 = Object.assign({}, group, { subscription: newObj1 });
					const newObj3 = Object.assign(group, newObj2);
					setGridProps(Object.assign(gridProps, newObj3));
					agGridRef.current.api.setRowData(gridProps);
				}
			});
		},
		[gridProps, setGridProps, tabValue]
	);

	const handleSubscribeCellRenderer = useCallback(
		(value: any) => {
			// if (alertSubscriptionsPermission.update) {
			return (
				<GreenCheckbox
					onClick={(event: any) => checkValueChangeClick(event, value.column.colId)}
					checked={
						value?.data?.subscription[value?.column?.colId] != undefined
							? value?.data?.subscription[value?.column?.colId][tabValue]
							: false
					}
				/>
			);
			// }
		},
		[checkValueChangeClick, tabValue]
	);

	// const handlePageChange = useCallback(
	// 	(_, value) => {
	// 		setPagination(
	// 			Object.assign({}, pagination, {
	// 				currentPage: value
	// 			})
	// 		);
	// 	},
	// 	[pagination]
	// );

	useEffect(() => {
		// Check if the current URL contains "employer"
		if (window.location.href.includes("employer")) {
			setIsEmployer(true);
		}
	}, []);

	// console.log("isEmployer--Check", isEmployer);
	// console.log("rolecheck--->", user?.role);
	// console.log(payloadForEmailOrNotifications, "payload");

	return (
		<div className="alert-subscription-grid-container glb-tab-grid-container">
			<div className="ag-theme-alpine" style={{ height: "400px", width: "100%" }}>
				<Suspense fallback={<div />}>
					<CustomDialog
						dialogProps={customSaveDialogProps}
						handleClose={handleCloseModalBulkAlertSubscription}
					/>
				</Suspense>
				<AgGridReact
					ref={agGridRef}
					rowData={gridProps}
					onGridReady={handleAgGridReady}
					onFirstDataRendered={handleFirstDataRendered}
					rowSelection={"multiple"}
					onSelectionChanged={handleSelectionChanged}
					animateRows
					frameworkComponents={{
						handleSubscribeCellRenderer: handleSubscribeCellRenderer,
						handleUserRoleCellRenderer: handleUserRoleCellRenderer,
						handleSSNCellRenderer: handleSSNCellRenderer,
						handleDateCellRenderer: handleDateCellRenderer
						// getCheckBoxValue: getCheckBoxValue
					}}
					suppressColumnVirtualisation={true}
					defaultColDef={{
						filter: "agTextColumnFilter",
						floatingFilter: true,
						resizable: true,
						filterParams: {
							suppressAndOrCondition: true
						}
					}}
					onCellValueChanged={(params) => {
						params.api.refreshCells({
							force: true
						});
					}}
				>
					<AgGridColumn
						field="first_name"
						headerName="First Name"
						suppressSizeToFit={true}
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						pinned="left"
					></AgGridColumn>
					<AgGridColumn
						field="last_name"
						headerName="Last Name"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						//suppressSizeToFit={true}
						pinned="left"
					></AgGridColumn>
					<AgGridColumn
						field="date_of_birth"
						headerName="Date Of Birth"
						pinned="left"
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						cellRenderer="handleDateCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field="role"
						headerName="Role"
						pinned="left"
						suppressSizeToFit={true}
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						cellRenderer="handleUserRoleCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field="SSN"
						headerName="SSN"
						pinned="left"
						suppressSizeToFit={true}
						floatingFilterComponentParams={{ suppressFilterButton: true }}
						cellRenderer="handleSSNCellRenderer"
					></AgGridColumn>
					{isEmployer || user?.role === ROLES.employer ? null : (
						<AgGridColumn
							field={ALERT_SUBSCRIPTION_FIELD.super_admin_registration}
							headerName="Super Admin Registration"
							filter={false}
							suppressSizeToFit={true}
							cellRenderer="handleSubscribeCellRenderer"
						/>
					)}
					{isEmployer || user?.role === ROLES.employer ? null : (
						<AgGridColumn
							field={ALERT_SUBSCRIPTION_FIELD.admin_creation}
							headerName="Admin Creation"
							filter={false}
							suppressSizeToFit={true}
							cellRenderer="handleSubscribeCellRenderer"
						></AgGridColumn>
					)}
					{isEmployer || user?.role === ROLES.employer ? null : (
						<AgGridColumn
							field={ALERT_SUBSCRIPTION_FIELD.admin_registration}
							headerName="Admin Registration"
							suppressSizeToFit={true}
							filter={false}
							cellRenderer="handleSubscribeCellRenderer"
						></AgGridColumn>
					)}
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.employer_creation}
						headerName="Employer Creation"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.employer_registration}
						headerName="Employer Registration"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.employee_creation}
						headerName="Employee Creation"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.employee_registration}
						headerName="Employee Registration"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.employee_profile_information_change}
						headerName="Employee Profile Change"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.employee_contact_information_change}
						headerName="Employee Contact Change"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.dependent_creation}
						headerName="Dependent Creation"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.dependent_registration}
						headerName="Dependent Registration"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.dependent_profile_information_change}
						headerName="Dependent Profile Change"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.dependent_contact_information_change}
						headerName="Dependent Contact Change"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.dependent_creation_request}
						headerName="Dependent Creation Request"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.dependent_creation_approval}
						headerName="Dependent Creation Approval"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.announcements}
						headerName="Announcements"
						cellRenderer="handleSubscribeCellRenderer"
						filter={false}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.blogs}
						headerName="Blogs"
						cellRenderer="handleSubscribeCellRenderer"
						filter={false}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.plan_creation}
						headerName="Plan Creation"
						filter={false}
						suppressSizeToFit={true}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.new_hire_enrollment}
						headerName="New Hire Enrollment"
						filter={false}
						suppressSizeToFit={true}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.enrollment_submission}
						headerName="Enrollment Submission"
						filter={false}
						suppressSizeToFit={true}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.open_enrollment}
						headerName="Open Enrollment"
						filter={false}
						suppressSizeToFit={true}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.benefit_change}
						headerName="Benefit Change"
						filter={false}
						suppressSizeToFit={true}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.termination}
						headerName="Termination"
						filter={false}
						suppressSizeToFit={true}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.reinstate_enrollment}
						headerName="Reinstate Employee"
						filter={false}
						suppressSizeToFit={true}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.rehire_enrollment}
						headerName="Rehire Employee"
						filter={false}
						suppressSizeToFit={true}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.statement_of_understanding}
						headerName="Statement of Understanding"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.registration_help}
						headerName="Registration Help"
						suppressSizeToFit={true}
						filter={false}
						cellRenderer="handleSubscribeCellRenderer"
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.grievance_logged}
						headerName="Grivence Logged"
						cellRenderer="handleSubscribeCellRenderer"
						filter={false}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.enroller_action}
						headerName="Enroller Action"
						cellRenderer="handleSubscribeCellRenderer"
						filter={false}
						suppressSizeToFit={true}
					></AgGridColumn>
					<AgGridColumn
						field={ALERT_SUBSCRIPTION_FIELD.portal_accessibility}
						headerName="Portal Accessibility"
						cellRenderer="handleSubscribeCellRenderer"
						filter={false}
						suppressSizeToFit={true}
					></AgGridColumn>
				</AgGridReact>
				<div style={{ marginTop: "10px", textAlign: "end" }}>
					<Button
						className="ag-grid-cell-button"
						variant="outlined"
						onClick={handleOpenModalBulkAlertSubscription}
					>
						Save
					</Button>
				</div>
			</div>
			{/* <div className="custom-pagination" id="custom-pagination">
				<CustomPagination pageCount={pageCount} currentPage={currentPage} handlePageChange={handlePageChange} />
			</div> */}
		</div>
	);
};

export default AlertSubscriptionGrid;
